import { atom } from 'jotai';
import { atomWithDefault } from 'jotai/utils';
import { atomFamily } from 'jotai-family';
import {
  FinancialsDateViewPreferences,
  getOrgPreferenceKey,
  PreferenceKey,
  PreferenceScope,
} from '../../../data-models/preferences-v3.data-model';
import { KpiPeriod } from '../../../data-models/company-financials.data-model';
import { preferenceAtom } from '../../../util/preferences-service-v3';
import { financialsDefaultDateViewOrgState } from '../../AdminPanel/DataDisplay/DataDisplayState';

const _financialsDateViewByCompanyPrefAtom = atomFamily((companyId: number) => {
  return preferenceAtom<FinancialsDateViewPreferences>([
    {
      preferenceKey: getOrgPreferenceKey(PreferenceKey.defaultFinancialsDateView, companyId),
      scope: PreferenceScope.ORGANIZATION,
    },
  ]);
});

export const financialsDateViewByCompanyAtom = atomFamily((companyId: number) =>
  atom(
    (get) => {
      return get(_financialsDateViewByCompanyPrefAtom(companyId)) ?? get(financialsDefaultDateViewOrgState);
    },
    (_get, set, newValue: FinancialsDateViewPreferences) => {
      set(_financialsDateViewByCompanyPrefAtom(companyId), newValue);
    }
  )
);

export const perfFrequencyAtom = atomFamily((companyId: number) =>
  atomWithDefault<KpiPeriod>((get) => get(financialsDateViewByCompanyAtom(companyId)).frequency)
);
